import React from 'react'
import { FileUpload, Input } from '../../../../../../../../../../itrust_common/components/form'
import { change, Field, formValueSelector } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import EyeMedFormButton from '../EyeMedFormButton'

const UPLOAD_FIELDS = [
  {
    name: 'upload_documentation_1',
    metadata: 'contact_lenses_1',
    label: '1. Supporting Documentation: Please upload the signed exam record from the initial exam and contact lens evaluation, including the diagnosis code and basic parameters for the initial lens being prescribed.',
  },
  {
    name: 'upload_documentation_2',
    metadata: 'contact_lenses_2',
    label: '2. Supporting Documentation: Please upload the point of sale documentation or statement of charges issued to the member. You do not need to include a lab invoice in your submission.',
  },
]

function ContactLensesDocuments({ attachments = [] }) {
  const dispatch = useDispatch()

  const handleUpload = (file, field) => {
    const { name, ...rest } = file || {}
    dispatch(change('EyeMedClaimForm', 'contact_lenses.attachments_attributes', [
      ...attachments.filter((item) => item.metadata !== field.metadata),
      { ...rest, metadata: field.metadata },
    ]))
  }

  const handleRemove = (index) => {
    dispatch(change(
      'EyeMedClaimForm',
      'contact_lenses.attachments_attributes',
      attachments.filter((_, i) => i !== index),
    ))
  }

  return (
    <div className="row">
      <div className="col-10">
        <div className="bg-white p-6 border rounded">
          <h5 className="mb-4 font-weight-bold">Contact Lenses Supporting Documentation</h5>
          {UPLOAD_FIELDS.map((field) => (
            <div key={field.name} className="mb-8">
              <p className="mb-5">
                <strong>Supporting Documentation: </strong>{field.label}
              </p>
              <div className="row">
                <Field
                  type="file"
                  label="Upload"
                  name={field.name}
                  component={FileUpload}
                  wrapperClasses="col-3 form-group"
                  imageClasses="py-3 px-5 uploaded-file-width"
                  onChangeHook={(file) => handleUpload(file, field)}
                />
                <div className="col-9">
                  <div className="row mx-0 py-5">
                    <p className="col-12 mb-0">Uploaded Documents:</p>
                    {attachments.map((item, index) => (
                      item.metadata === field.metadata && (
                        <div key={index} className="col-3 d-flex flex-column align-items-center position-relative">
                          <embed src={item.file} className="pt-5 img-fluid" style={{ height: '12rem', objectFit: 'fit' }} />
                          <p className="text-danger bg-light mb-0 pointer w-100 text-center py-2" onClick={() => handleRemove(index)}>
                            <i className="la la-trash" />
                          </p>
                        </div>
                      )
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
          <Field
            name="signers_name"
            component={Input}
            className="form-control"
            label="Signer's Name"
            wrapperClasses="form-group mb-8 col-6"
          />
          <EyeMedFormButton currentModule="Contact Lenses Supporting Documentation" />
        </div>
      </div>
    </div>
  )
}

const selector = formValueSelector('EyeMedClaimForm')

export default connect((state) => ({
  attachments: selector(state, 'contact_lenses.attachments_attributes') || [],
}))(ContactLensesDocuments)
